export default class ClientStore {
  constructor(routerStore, uiState) {
    this.routerStore = routerStore;
    this.uiState = uiState;
  }
}
